// removed by extract-text-webpack-plugin
module.exports = {"root":"NewslettersList__root--1cGwX","listItem":"NewslettersList__listItem--3225M","item":"NewslettersList__item--1KkjC","active":"NewslettersList__active--216d0","bounce":"NewslettersList__bounce--341Nv"};


//////////////////
// WEBPACK FOOTER
// ./src/subscriptions/components/NewslettersList/NewslettersList.css
// module id = ./src/subscriptions/components/NewslettersList/NewslettersList.css
// module chunks = 1